import PropTypes from 'prop-types';

export default PropTypes.oneOfType([
  PropTypes.shape({
    url: PropTypes.string,
  }),
  PropTypes.string,
]);
